import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';


@Directive({
  selector: '[usdOnly]',
  exportAs: 'usdOnly',
  standalone: false
})
export class UsdOnlyDirective implements OnInit {
  currencyChars = new RegExp('[$,]', 'g'); // we're going to remove commas and dots

  constructor(public el: ElementRef, public renderer: Renderer2, private decimalPipe: DecimalPipe, private ngControl: NgControl) {}

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    this.format(this.el.nativeElement.value); // format any initial values
  }

  @HostListener('input', ["$event.target.value"]) onInput(e: string) {
    this.format(e);
  };

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.format(event.clipboardData.getData('text/plain'));
  }

  format(val:string) {
    if ( !this.ngControl.control.value) {
      return;
    }
    // 1. test for non-number characters and replace/remove them
    const numberFormat = parseInt(String(val).replace(this.currencyChars, '')) || 0;
    // Set number value to input
    this.ngControl.control.patchValue(numberFormat);
    // 2. format the number (add commas)
    const usd = this.decimalPipe.transform(numberFormat, '1.0', 'en-US');
    // 3. replace the input value with formatted numbers
    
    //this.renderer.setProperty(this.el.nativeElement, 'value', usd);
    this.el.nativeElement.value = `$${usd}`;
  }

}